import { render } from "./EmailAlertsSettingsForm.vue?vue&type=template&id=49e83f03&ts=true"
import script from "./EmailAlertsSettingsForm.vue?vue&type=script&lang=ts"
export * from "./EmailAlertsSettingsForm.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__